import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";

const LanjutanInvestigasi = ({ fieldStyles, setInputFields, inputFields }) => {
  const potensiTingkatKeparahanItem = [
    { value: "Insignificant", name: "Insignificant" },
    { value: "Minor", name: "Minor" },
    { value: "Moderate", name: "Moderate" },
    { value: "Significant", name: "Significant" },
    { value: "Catastrophic", name: "Catastrophic" },
  ];

  const probabilitasKejadianItem = [
    { value: "1", name: "1" },
    { value: "2", name: "2" },
    { value: "3", name: "3" },
    { value: "4", name: "4" },
    { value: "5", name: "5" },
  ];

  const pelaksanaanInvestigasiItem = [
    { value: "Lokasi", name: "Lokasi" },
    { value: "Regional", name: "Regional" },
    { value: "Subholding", name: "Subholding" },
  ];

  const [radioInvestigasi, setRadioInvestigasi] = useState("tidak");

  return (
    <Box component="div" sx={fieldStyles}>
      <Grid>
        <Stack spacing={2} direction="row">
          <FormControl variant="standard" fullWidth>
            <FormLabel id="radio1">
              <small className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-standard MuiFormLabel-colorPrimary MuiFormLabel-filled css-1c2i806-MuiFormLabel-root-MuiInputLabel-root">
                Perlu Dilakukan Investigasi
              </small>
            </FormLabel>
            {/* <InputLabel id="idPK">Perlu Dilakukan Investigasi</InputLabel> */}
            <RadioGroup
              row
              aria-labelledby="radio1"
              name="row-radio-buttons-group"
              style={{ marginTop: "10px" }}
              onChange={(e) => {
                setRadioInvestigasi(e.target.value);
                //   setInputFields({
                //     ...inputFields,
                //     idKategoriHipo: e.target.value,
                //   });
              }}
              value={radioInvestigasi}
            >
              <FormControlLabel value={"ya"} control={<Radio />} label={"Ya"} />
              <FormControlLabel
                value={"tidak"}
                control={<Radio />}
                label={"Tidak"}
              />
            </RadioGroup>
          </FormControl>
          <FormControl variant="standard" fullWidth>
            <InputLabel id="idPTK">Potensi Tingkat Keparahan</InputLabel>
            <Select
              labelId="lbl1"
              id="idPTK"
              label="Potensi Tingkat Keparahan"
              onChange={(e) => {
                setInputFields({
                  ...inputFields,
                  potensiTingkatKeparahan: e.target.value,
                });
              }}
              disabled={radioInvestigasi === "tidak"}
            >
              {potensiTingkatKeparahanItem.map((item, idx) => (
                <MenuItem value={item.value} key={idx}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
        <Stack spacing={2} direction="row">
          <FormControl variant="standard" fullWidth>
            <InputLabel id="idPTK">Probabilitas Kejadian</InputLabel>
            <Select
              labelId="lbl1"
              id="idPTK"
              label="Probabilitas Kejadian"
              onChange={(e) => {
                setInputFields({
                  ...inputFields,
                  probabilitasTingkatKeparahan: e.target.value,
                });
              }}
              disabled={radioInvestigasi === "tidak"}
            >
              {probabilitasKejadianItem.map((item, idx) => (
                <MenuItem value={item.value} key={idx}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl variant="standard" fullWidth>
            <InputLabel id="idPK">Pelaksanaan Investigasi</InputLabel>
            <Select
              labelId="lbl1"
              id="idPK"
              label="Pelaksanaan Investigasi"
              onChange={(e) => {
                setInputFields({
                  ...inputFields,
                  probabilitasKejadian: parseInt(e.target.value),
                });
              }}
              disabled={radioInvestigasi === "tidak"}
            >
              {pelaksanaanInvestigasiItem.map((item, idx) => (
                <MenuItem value={item.value} key={idx}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      {/* <p style={{ color: "red" }}>
        <small>
          Keterangan*){" "}
          <span style={{ color: "black" }}>
            Sesuai Pedoman Pengelolaan HSSE Berbasis Resiko
          </span>
        </small>
      </p> */}
    </Box>
  );
};

export default LanjutanInvestigasi;
